import { LoginLayout } from '@layouts/login';
import { StaffLoginForm } from '@components/forms/staff/login';
import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';

function AcquirerLogin() {
  const { t } = useTranslation('app');

  return (
    <LoginLayout title={t('pages.login.title')}>
      <StaffLoginForm />
    </LoginLayout>
  );
}

export const Route = createFileRoute('/staff/login')({
  component: AcquirerLogin,
});
